var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6665 8.5013L3.6065 9.4413L7.33317 5.7213V13.8346H8.6665V5.7213L12.3865 9.44797L13.3332 8.5013L7.99984 3.16797L2.6665 8.5013Z",
    fill: "#3C228A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4729_57691",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 12,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6665 8.5013L3.6065 9.4413L7.33317 5.7213V13.8346H8.6665V5.7213L12.3865 9.44797L13.3332 8.5013L7.99984 3.16797L2.6665 8.5013Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4729_57691)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortActive);
export default __webpack_public_path__ + "static/media/sort-active.d1643a4397ca1358050e62175cbebf19.svg";
export { ForwardRef as ReactComponent };